import * as ui from "../../app/core/ui";

var view = () => new ui.Pane({
    id: "UploadPicturePane",
    header: "UploadPicture",
    components: [
        new ui.Container({
            id: "UploadPictureContainer"
        })
    ]
});

export default view;
